module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "studentStatistics"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("作业报告")]), _vm._v(" "), _c('div', {
    staticClass: "contentReport"
  }, [_c('rankHeader', {
    attrs: {
      "classList": _vm.classList,
      "className": _vm.className,
      "wechatUrl": _vm.wechatUrl,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "shareFlag": true
    },
    on: {
      "changClassId": _vm.changClassId,
      "changedPicker": _vm.changedPicker,
      "getWorkStatistics": _vm.getWorkStatistics
    }
  }), _vm._v(" "), (!_vm.studentScore.length) ? _c('div', {
    staticClass: "scoreTable"
  }, [_c('noFound')], 1) : _c('div', {
    staticClass: "scoreTable"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("成绩排名")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("提交率")]), _vm._v(" "), _c('th', [_vm._v("\n            得分\n            "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "时间段内，学生作业得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('th', [_vm._v("作业时长")]), _vm._v(" "), _c('th', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.studentScore), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ranking))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.submitRate) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.avgScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("secTotime1")(item.totalTime)))]), _vm._v(" "), _c('td', {
      staticClass: "watchInfo",
      on: {
        "click": function($event) {
          _vm.lookOneStudent(item)
        }
      }
    }, [_vm._v("\n            查看详情\n          ")])])
  }))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665e2978","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/studentReport.vue
// module id = 1209
// module chunks = 1